<template>
	<app-content class="h-panel">
		<div class="h-panel-bar"><span class="h-panel-title">系统公告</span></div>
		<div class="margin-top margin-left margin-right">
			<div style="display: flex;">
				<input type="text" v-model="title" placeholder="输入标题搜索" style="width: 240px;"
					   @keyup.enter="doSearch"/>
				<Button color="primary" :loading="loading" @click="doSearch">搜索</Button>
				<Button color="primary" style="margin-left: auto;" icon="fa fa-plus" @click="openForm()">新增公告</Button>
			</div>
		</div>
		<div class="h-panel-body">
			<Table :datas="dataList" :loading="loading">
				<TableItem prop="id" title="ID" :width="70"/>
				<TableItem prop="title" title="标题"/>
				<TableItem prop="type" title="类型" :width="90" align="center">
					<template slot-scope="{data}">
						<span class="h-tag" :class="data.type === '公告' ? 'h-tag-blue' : 'h-tag-green'">{{ data.type || '通知' }}</span>
					</template>
				</TableItem>
				<TableItem title="状态" :width="80" align="center">
					<template slot-scope="{data}">
						<span :class="data.status === 1 ? 'green-color' : 'red-color'">{{ data.status === 1 ? '已发布' : '已下架' }}</span>
					</template>
				</TableItem>
				<TableItem title="发布时间" :width="150">
					<template slot-scope="{data}">{{ datetimeFormat(data.publishDate) }}</template>
				</TableItem>
				<TableItem title="创建时间" :width="150">
					<template slot-scope="{data}">{{ datetimeFormat(data.createDate) }}</template>
				</TableItem>
				<TableItem title="操作" :width="150" align="center">
					<div class="actions" slot-scope="{data}">
						<span @click="openForm(data)">编辑</span>
						<span @click="toggleStatus(data)">{{ data.status === 1 ? '下架' : '发布' }}</span>
						<span class="red-color" @click="remove(data)">删除</span>
					</div>
				</TableItem>
			</Table>
			<Pagination style="margin-top: 10px;" v-model="pagination" layout="total,sizes,pager,jumper"
						@change="loadList" small align="right"/>
		</div>

		<Modal v-model="showForm" hasCloseIcon hasDivider :closeOnMask="false">
			<div slot="header">{{ form.id ? '编辑公告' : '新增公告' }}</div>
			<Form :labelWidth="90" ref="form" :rules="validationRules" :model="form">
				<FormItem label="标题" prop="title">
					<input type="text" v-model="form.title" maxlength="128" placeholder="公告标题"/>
				</FormItem>
				<FormItem label="类型" prop="type">
					<Radio v-model="form.type" :datas="['通知', '公告']"></Radio>
				</FormItem>
				<FormItem label="内容" prop="content">
					<textarea v-model="form.content" rows="5" maxlength="2000" placeholder="公告内容"></textarea>
				</FormItem>
				<FormItem label="状态" prop="status">
					<Radio v-model="form.status" :datas="[{key: 1, title: '发布'}, {key: 0, title: '下架'}]"></Radio>
				</FormItem>
			</Form>
			<div slot="footer">
				<Button @click="showForm=false">取消</Button>
				<Button color="primary" :loading="saving" @click="save">保存</Button>
			</div>
		</Modal>
	</app-content>
</template>

<script>
	import moment from 'moment';

	export default {
		name: "AdminAnnouncements",
		data() {
			return {
				loading: false,
				saving: false,
				showForm: false,
				title: '',
				dataList: [],
				pagination: {page: 1, size: 20, total: 0},
				form: {},
				validationRules: {
					required: ['title', 'content']
				}
			}
		},
		methods: {
			loadList() {
				this.loading = true;
				this.$api.admin.announcements({
					page: this.pagination.page,
					size: this.pagination.size,
					title: this.title || undefined
				}).then(({data}) => {
					this.dataList = data.records || [];
					this.pagination.total = Number(data.total || 0);
				}).finally(() => this.loading = false);
			},
			doSearch() {
				this.pagination.page = 1;
				this.loadList();
			},
			openForm(data) {
				this.form = data
					? Object.assign({}, data)
					: {title: '', type: '通知', content: '', status: 1};
				this.showForm = true;
			},
			save() {
				if (!this.$refs.form.valid().result) {
					return;
				}
				this.saving = true;
				let request = this.form.id
					? this.$api.admin.updateAnnouncement(this.form)
					: this.$api.admin.addAnnouncement(this.form);
				request.then(() => {
					this.$Message.success('保存成功~');
					this.showForm = false;
					this.loadList();
				}).finally(() => this.saving = false);
			},
			toggleStatus(data) {
				let next = data.status === 1 ? 0 : 1;
				this.$api.admin.updateAnnouncement({id: data.id, status: next, publishDate: null}).then(() => {
					this.$Message.success(next === 1 ? '已发布' : '已下架');
					this.loadList();
				});
			},
			remove(data) {
				this.$Confirm(`确认删除公告【${data.title}】?`).then(() => {
					this.$api.admin.deleteAnnouncement({id: data.id}).then(() => {
						this.$Message.success('删除成功~');
						this.loadList();
					});
				});
			},
			datetimeFormat(date) {
				return date ? moment(date).format('YYYY-MM-DD HH:mm') : '';
			}
		},
		mounted() {
			this.loadList();
		}
	}
</script>

<style lang="less" scoped>
	.actions {
		span {
			color: #1890ff;
			cursor: pointer;
			margin: 0 6px;

			&:hover {
				text-decoration: underline;
			}

			&.red-color {
				color: #f5222d;
			}
		}
	}
</style>
